module.exports = __webpack_public_path__ + "static/img/no-collection.3b70aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-collection.png
// module id = E4rz
// module chunks = 3